import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useIDCREASChartsDataContext } from './hooks/useIDCREASChartsDataContext';

export const StructureEvolutionChart = () => {
    const { chartData } = useIDCREASChartsDataContext();

    return (
        <SimpleBars
            title="Evolução Anual de Estrutura Física"
            subtitles={chartData.structure.map((item) => getYearLabel(item.ano))}
            values={chartData.structure.map(
                (item) => Number(item.estrutura_fisica) || 0
            )}
        />
    );
};
